import React from 'react'
import { Text } from 'react-form'
import {Form, Col, FormGroup, Button, ControlLabel} from 'react-bootstrap'
import {convertYearToJalali, convertYearToGregorian, matchableDates} from '../../../utils/dateHelper'

export default ({values, bornOn, setValue, getValue, submitForm}) => {
  return (
    <Form horizontal onSubmit={submitForm}>
      <FormGroup>
        <Col componentClass={ControlLabel} xs={4}>
          مرگ
        </Col>
        <Col xs={8}>
          <Text
            field="death_date"
            type="number"
            placeholder={bornOn + 1}
            className="form-control"
            onKeyDown={(e) => {
              if (getValue('death_date').length === 3) {
                e.preventDefault()
                let gregorianYear = getValue('death_date') + e.key
                setValue('death_date', gregorianYear)
                if (!getValue('death_date_fa')) {
                  return setValue('death_date_fa', convertYearToJalali(gregorianYear))
                }
                if (!matchableDates(gregorianYear, getValue('death_date_fa'))) {
                  setValue('death_date_fa', convertYearToJalali(gregorianYear))
                }
              }
            }}
            />
        </Col>
      </FormGroup>

      <FormGroup>
        <Col componentClass={ControlLabel} xs={4}>
          معادل
        </Col>
        <Col xs={8}>
          <Text
            field="death_date_fa"
            type="number"
            placeholder={convertYearToJalali(bornOn) + 1}
            className="form-control"
            onKeyDown={(e) => {
              if (getValue('death_date_fa').length === 3) {
                e.preventDefault()
                let jalaliYear = getValue('death_date_fa') + e.key
                setValue('death_date_fa', jalaliYear)
                if (getValue('death_date').length === 0) {
                  return setValue('death_date', convertYearToGregorian(jalaliYear))
                }
                if (!matchableDates(getValue('death_date'), jalaliYear)) {
                  setValue('death_date', convertYearToGregorian(jalaliYear))
                }
              }
            }}
            />
        </Col>
      </FormGroup>

      <FormGroup>
        <Col xsOffset={4} xs={8}>
          <Button type="submit" className="btnBlock" bsStyle="info">
            ثبت مرگ
          </Button>
        </Col>
      </FormGroup>
    </Form>
  )
}



// WEBPACK FOOTER //
// ./src/components/HorseInfo/DieReport/DieReportForm.js